var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_16408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 3.55823C17.4707 3.55823 21.5001 7.58766 21.5001 12.5582C21.5001 17.5288 17.4707 21.5582 12.5001 21.5582C7.52956 21.5582 3.50012 17.5288 3.50012 12.5582C3.50012 7.58766 7.52956 3.55823 12.5001 3.55823Z",
    fill: "#1851B0",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50012 13.5582L12.5001 9.55823L16.5001 13.5582",
    stroke: "#1859B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_16408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.500122 24.5582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.2560805148fab6a8e0d5f2b5dcef8db8.svg";
export { ForwardRef as ReactComponent };